import { ApolloError } from "@apollo/client";
import { useMemo } from "react";
import { formatISO } from "date-fns";
import { ReportVersionListFieldsFragment, useAllReportVersionsListQuery } from "app/api/graph/types";
import { mapNodes } from "app/util/graph";
import { useFetchAll } from "app/api/graph/hook/use-fetch-all";

type Result = {
    versions?: ReportVersionListFieldsFragment[];
    loading: boolean;
    error?: ApolloError;
};

type Filters = {
    publishedAtFrom?: Date;
    publishedAtTo?: Date;
};

export const useAllReportVersionsList = (filters?: Filters): Result => {
    const { data, loading, error, fetchMore } = useAllReportVersionsListQuery({
        notifyOnNetworkStatusChange: true,
        variables: {
            ...(filters && {
                publishedAt: {
                    after: filters.publishedAtFrom ? formatISO(filters.publishedAtFrom) : undefined,
                    before: filters.publishedAtTo ? formatISO(filters.publishedAtTo) : undefined,
                },
            }),
        },
    });
    const versions = data?.reportVersions;
    const pageInfo = versions?.pageInfo;
    useFetchAll({ loading, pageInfo, fetchMore });

    return useMemo(
        () => ({
            versions: mapNodes(versions, (n) => n),
            loading,
            error,
        }),
        [versions, loading, error],
    );
};
